import Temp from "@/courier/Temp";
import {courierDetail as _COURIERS_} from "@/config/courierCodes";
import courierRules from "../constants/CourierRules";
export default class DHLExpress extends Temp {
  static CODE = _COURIERS_.DHL.key;

  constructor() {
    super(DHLExpress.CODE);
  }
  getZone(item) {
    let type;
    let cross_price, remote_area;
    cross_price = remote_area = 0;
    // let prefixFromPostCode = item.fromPostcode.toString().substring( 0 , 2 )
    const from_remote_area = super.checkRemoteArea(Number(item.fromPostcode));
    const to_remote_area = super.checkRemoteArea(Number(item.toPostcode));
    remote_area =  to_remote_area;
    type = super.checkZone(item.toPostcode.toString());
    if (type == 3) type = 2;
    if (type > 3) type = 3;
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
    };
  }
  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }
  calculateExtraHandlingCharge(parcel) {
    const totalGirth = Number(parcel.width) + Number(parcel.length) + Number(parcel.height);
    // condition -> https://shippop.atlassian.net/browse/SP-5742 
    if (totalGirth > 250 || parcel.weight > 35000) {
      return 350;
    }
    return 0;
  }
  checkWeight(courierRates, item) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });
    return {
      index: item.index,
    };
  }
  async checkRemoteAreaByCorrectorOrigin(addressRemote) {
    return new Promise((resolve) => {
      resolve(false);// disable origin
      super.getArea([addressRemote], ["DHL"], option).then((res) => {
        let remoteArea = res.data.DHL.is_remote?40:0;
        resolve(remoteArea);
      });
    });
  }
  async checkRemoteAreaByCorrectorDest(addressRemote, option) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["DHL"], option).then((res) => {
        let remoteArea = res.data.DHL.is_remote?40:0;
        resolve(remoteArea);
      });
    });
  }
}
